import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import LineupCard from "./lineupCard";

const kebabCase = (string) => {
	return string
		.replace(/\s+/g, "-")
		.toLowerCase()
		.replace(/[^a-zA-Z0-9-_]/g, "");
};

/* Lineup
============================================================================= */

const Lineup = () => {
	// Config
	const data = useStaticQuery(
		graphql`
			query {
				allSanityArtist {
					nodes {
						name
						image {
							asset {
								gatsbyImageData(
									width: 512
									placeholder: BLURRED
									formats: [AUTO, WEBP, AVIF]
								)
							}
						}
					}
				}
			}
		`
	);

	// Render Artists
	const renderArtists = () => {
		return data.allSanityArtist.nodes
			.sort((a, b) => {
				return a.name.localeCompare(b.name);
			})
			.map((artist) => {
				return (
					<LineupCard
						name={artist.name}
						fluid={artist.image.asset.gatsbyImageData}
						key={artist.name}
					/>
				);
			});
	};

	// Render
	return (
		<section className="artist-lineup">
			<div className="artist-container">{renderArtists()}</div>
		</section>
	);
};

/* Artist Item
============================================================================= */

const ArtistItem = ({ artist }) => {
	// Config

	// Render
	return (
		<div className="w-full h-full">
			<h1>{artist.name}</h1>
		</div>
	);
};

/* Export
============================================================================= */

export default Lineup;
